export function formatCountPlural(
  count: number,
  singular: string,
  plural: string
) {
  const displayCount = Number(count).toLocaleString();
  if (count > 1) {
    return `${displayCount} ${plural}`;
  }
  return `${displayCount} ${singular}`;
}
